// src/hooks/usePhoneNumbers.js
import { useState, useEffect, useCallback } from 'react'
import { getPhoneNumbers, addPhoneNumber, deletePhoneNumber, assignPhoneNumber, updatePhoneNumber, getLatestPhoneByAgent } from '../db/index.js'

export function usePhoneNumbers() {
  const [phones,  setPhones]  = useState([])
  const [historyByAgent, setHistoryByAgent] = useState({})
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    try {
      const [rows, hist] = await Promise.all([getPhoneNumbers(), getLatestPhoneByAgent()])
      setPhones(rows)
      setHistoryByAgent(hist)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { load() }, [load])

  const add = useCallback(async (number) => {
    const row = await addPhoneNumber(number)
    setPhones(prev => [...prev, row].sort((a, b) => a.number.localeCompare(b.number)))
    return row
  }, [])

  const remove = useCallback(async (id) => {
    await deletePhoneNumber(id)
    setPhones(prev => prev.filter(r => r.id !== id))
  }, [])

  const assign = useCallback(async (id, agentId) => {
    const updated = await assignPhoneNumber(id, agentId)
    setPhones(prev => prev.map(r => {
      // Clear from previous holder
      if (agentId && r.agent_id === agentId && r.id !== id) return { ...r, agent_id: null }
      if (r.id === id) return updated
      return r
    }))
    return updated
  }, [])

  const update = useCallback(async (id, updates) => {
    const updated = await updatePhoneNumber(id, updates)
    setPhones(prev => prev.map(r => r.id === id ? updated : r))
    return updated
  }, [])

  return { phones, historyByAgent, loading, add, remove, assign, update, reload: load }
}
